
<template>

    <div>

        <div class="order-tab">

            <div class="order-tab-top-section">

                <div class="merchant-header-wrap">

                    <p class="merchant-name">{{ currentMerchant.name }}</p>
                    <p class="merchant-location">{{ currentLocation.name }}</p>
                </div>
                <div class="order-outer-wrapper">

                    <p class="order-title">Your Order: <span @click=" clearTab() ">Remove All</span></p>
                    <ul class="order-list">

                        <li :class=" tabItemClasses( item ) " v-for=" ( item, key ) in currentTab " :key=" key ">

                            <div class="item-quantity">

                                <p v-if=" itemValid( item ) ">{{ item.quantity + 'x' }}</p>
                                <font-awesome-icon v-else style=" color: red " icon="exclamation-triangle" />
                            </div>
                            <div class="item-details">

                                <p class="item-name">{{ item.name }}</p>
                                <p v-if=" item.reason " class="unavailable-reason">{{ item.reason }}</p>
                                <p :class=" modifierTitleClasses( mod ) " v-if=" item.available != 0 " v-for=" ( mod, modKey ) in item.modifiers" :key=" modKey " >{{ mod.split( "_" )[ 5 ] }}</p>
                                <p v-if=" item.available != 0" class="edit-button" @click=" initEditItem( item ) ">Edit</p>
                            </div>
                            <div class="item-price">

                                <span>{{ '$' + item.price }}</span>
                                <p class="remove-button" @click=" removeItem( item ) ">Remove</p>
                            </div>
                        </li>
                        <li class="order-note">

                            <textarea maxlength="50" rows="3" columns="50" placeholder="Add Note ( extra napkins, extra sauce... )" @blur=" updateNote( $event.target.value ) "></textarea>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="order-tab-bottom-section">

                <TipWidget />

                <div class="order-fees-wrapper">

                    <div class="order-subtotal-wrapper">

                        <p class="order-subtotal-title">Subtotal</p>
                        <p class="order-subtotal-number">${{ totalTicketAmount.toFixed( 2 ) }}</p>
                    </div>
                    <div class="order-tax-wrapper">

                        <p class="order-tax-title">Tax</p>
                        <p class="order-tax-number">${{ getTax.toFixed( 2 ) }}</p>
                    </div>
                    <div class="order-tip-wrapper">

                        <p class="order-tip-title">Tip</p>
                        <p class="order-tip-number">${{ orderTip }}</p>
                    </div>
                    <div class="order-total-wrapper">

                        <p class="order-total-title">Total</p>
                        <p class="order-total-number">${{ orderTotal }}</p>
                    </div>
                </div>

                <!-- <div class="order-payment-wrapper" v-if=" false ">

                    <div class="order-payment-details" v-if=" profileInfo.cardDetails.cardLast4 != null ">

                        <img :src=" './img/' + profileInfo.cardDetails.cardImage " class="" />
                        <p class="card-details">

                            <span v-if=" profileInfo.cardDetails.cardNetwork == 'AMEX' ">&#183;&#183;&#183;&#183; &#183;&#183;&#183;&#183;&#183;&#183; &#183;</span>
                            <span v-else><span v-for=" i in 3 " :key=" i ">&#183;&#183;&#183;&#183; </span></span>
                            {{ profileInfo.cardDetails.cardLast4 }}
                        </p>
                    </div>
                    <div class="no-card" v-else>

                        No Card on File
                    </div>
                    <div class="save-card">

                        <label for="keepCard">Save my card</label>
                        <input type="checkbox" id="keepCard" :value=" saveCard " @click=" toggleSaveCard() "/>
                    </div>
                </div> -->

                <OrderError />

                <div class="checkout-tab">

                    <button class="button btn-blue" @click=" cardOnFile() " :disabled=" currentTab.length < 1 || invalidItemsExist ">

                        Checkout
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import { mapState, mapGetters, mapActions } from 'vuex';
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    import OrderError from '../misc/OrderError';
    import TipWidget from '../misc/TipWidget';

    export default {

        name: 'order-tab',
        methods: {

            ...mapActions({

                removeItem  : 'orderTab/removeItem',
                clearTab    : 'orderTab/clearTab'
            }),
            tabItemClasses( item ){

                const base = [ 'order-item' ];
                base.push( item.available == 0 ? 'unavailable-item' : '' );
                base.push( this.hasUnavailableModifiers( item ) ? 'unavailable-modifiers' : '' );
                return base.join( ' ' );
            },
            hasUnavailableModifiers( item ){

                for( var i = 0; i < item.modifiers.length; i++ ){

                    const modArray = item.modifiers[ i ].split( '_' );
                    if( modArray[ modArray.length - 1 ] == 'unavailable' ){

                        item.modsValid = 0;
                        item.reason = 'modifier(s) unavailable';
                        return true;
                        break;
                    }
                }
                return false;
            },
            itemValid( item ){

                if( item.available == 0 ) return false;
                else return !this.hasUnavailableModifiers( item );
            },
            modifierTitleClasses( mod ){

                const base = [ 'item-modifier' ];
                const modArray = mod.split( '_' );
                base.push( modArray[ modArray.length - 1 ] == 'unavailable' ? 'strikethrough' : '' );
                return base.join( ' ' );
            },
            initEditItem( item ){

                this.$emit( 'toggleTab' );
                this.$router.push( { name : 'order-menu' } );
                this.$store.dispatch( 'orderMenu/chooseItem', item )
                    .then( () => {

                        setTimeout( () => {

                            this.$store.dispatch( 'orderMenu/editItem', item );
                        }, 500 );
                })
            },
            cardOnFile(){

                if( parseInt( this.currentLocation.acceptingOrders ) == 0 ){

                } else if( window.PaymentRequest ) {

                    // Use Payment Request API
                    const supportedPaymentMethods = [
                        {

                            supportedMethods: 'basic-card',
                            data : {

                                supportedNetworks : [ 'visa', 'mastercard', 'amex', 'diners', 'discover' ],
                                supportedTypes    : [ 'credit', 'debit' ]
                            }
                        }
                    ];

                    const paymentDetails = {

                        total: {

                            label: 'Total Purchase',
                            amount: {

                                currency: 'USD',
                                value: ( parseFloat( this.getTax.toFixed( 2 ) ) + parseFloat( this.totalTicketAmount.toFixed( 2 ) ) + parseFloat( this.orderTip ) ).toFixed( 2 )
                            }
                        },
                        displayItems : this.paymentApiItems
                    };

                    // Options isn't required.
                    const options = {

                        requestPayerName : true,
                        requestPayerPhone: true,
                        requestPayerEmail: true
                    };

                    const req = new PaymentRequest(

                        supportedPaymentMethods,
                        paymentDetails,
                        options
                    );

                    req.canMakePayment()
                    .then( res => {

                        if( false ) {

                            req.show()
                            .then( paymentResponse => {

                                console.log( 'The payment response: ', paymentResponse );
                                let formattedData = null;
                                switch( paymentResponse.methodName ){

                                    case 'basic-card' :

                                        formattedData = {

                                            'card'     : paymentResponse.details.cardNumber,
                                            'expYear'  : paymentResponse.details.expiryYear,
                                            'expMonth' : paymentResponse.details.expiryMonth,
                                            'code'     : paymentResponse.details.cardSecurityCode,
                                            'name'     : paymentResponse.details.cardholderName,
                                            'city'     : paymentResponse.details.billingAddress.city,
                                            'state'    : paymentResponse.details.billingAddress.region,
                                            'zip'      : paymentResponse.details.billingAddress.postalCode
                                        };
                                        break;
                                    default:

                                        console.log( 'ERROR: unknown payment method' );
                                        break;
                                };
                                return this.$store.dispatch( 'orderTab/processPaymentInfo', formattedData )
                                .then( ( encryptedData ) => {
                                    if ( encryptedData ) {

                                        console.log( 'Encrypted Data: ', encryptedData );
                                        // also passing in saveCard to signal if we should save the card information
                                        this.$store.dispatch( 'orderTab/submitOrder', encryptedData );
                                        return paymentResponse.complete( 'success' );
                                    } else {

                                        return paymentResponse.complete( 'fail' );
                                    }
                                })
                            })
                            .catch( ( err ) => {

                                console.error( 'unfortunately the payment api ran into an error...', err );
                            });
                        } else { // should probably do the same thing HERE

                            // Safari usually goes here
                            this.$router.push( { name: 'payment' } );
                        }
                    }).catch( err => { // should MAYBE do the same thing HERE???

                        alert( 'catching canMakePayment(), take a screenshot for erik. Note your browser and device type' );
                        this.$router.push( { name: 'payment' } );
                    })
                } else { // should probably do the same thing HERE

                    // Mike Got here with FireFox - must have no Payment API
                    this.$router.push( { name: 'payment' } );
                    // throw this in here during testing to see if this is a problem that needs to be addressed
                }
            },
            toggleSaveCard(){

                this.$store.dispatch( 'orderTab/toggleSaveCard' );
            },
            updateNote( value ){

                const sanitized = String( value ).replace(/([-()\[\]{}+?*.$\^|:#<!\\])/g, '').
                    replace(/\x08/g, '\\x08');
                this.$store.dispatch( 'orderTab/updateNote', sanitized );
            }
        },
        computed: {

            ...mapState({

                currentTab       : state => state.orderTab.currentTab,
                previousMenuView : state => state.orderMenu.previousMenuView,
                selectedCategory : state => state.orderMenu.selectedCategory
            }),
            ...mapGetters({

                totalTicketAmount : 'orderTab/getCost',
                getTax            : 'orderTab/getTax',
                currentMerchant   : 'merchant/currentMerchant',
                currentLocation   : 'merchant/currentLocation',
                profileInfo       : 'auth/profileInfo',
                orderTotal        : 'orderTab/orderTotal',
                saveCard          : 'orderTab/saveCard',
                orderError        : 'orderTab/orderError'
            }),
            invalidItemsExist(){

                let exists = false;
                this.currentTab.forEach( tabItem => {

                    for( var i = 0; i < tabItem.modifiers.length; i++ ){

                        const modArray = tabItem.modifiers[ i ].split( '_' );
                        if( modArray[ modArray.length - 1 ] == 'unavailable' ){

                            console.log( 'getting here..' );
                            exists = true;
                            break;
                        }
                    }
                });
                return exists;
            },
            orderTip: {

                get(){

                    return this.$store.getters[ 'orderTab/orderTip' ];
                },
                set( value ){

                    this.$store.commit( 'orderTab/updateTip', value );
                }
            },
            paymentApiItems: function() {

                const items = [];
                items.push({

                    label : 'subtotal',
                    amount: {

                        currency : 'USD',
                        value    : this.totalTicketAmount.toFixed( 2 )
                    }
                });
                items.push({

                    label : 'tax',
                    amount: {

                        currency : 'USD',
                        value    : this.getTax.toFixed( 2 )
                    }
                });
                items.push({

                    label : 'tip',
                    amount: {

                        currency : 'USD',
                        value    : this.orderTip
                    }
                });
                return items;
            }
        },
        components: {

            TipWidget,
            FontAwesomeIcon,
            OrderError
        }
    }
</script>

<style scoped>

    .order-tab {

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        height: 100%;
    }

    .merchant-header-wrap {

        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        height: 105px;
    }
    .merchant-name {

        font-size: 1.6rem;
        font-weight: bold;
        margin: 0 0 5px;
    }
    .merchant-location {

        font-size: 1rem;
        font-weight: bold;
        margin: 0;
    }

    .order-outer-wrapper {

        box-sizing: border-box;
        padding: 0 15px;
    }
    .order-title {

        margin: 0;
        font-weight: bolder;
        color: #444;
        display: flex;
        justify-content: space-between;
    }
        .order-title > span {

            color: rgb( 173, 8, 8 );
            cursor: pointer;
        }
    .order-list {

        list-style: none;
        margin: 10px 0; padding: 0;
        width: 100%;
        min-height: 140px;
    }
    .order-item {

        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 25px 0px;
        color: #333;
        border-bottom: 1px solid #ccc;
    }
    .unavailable-item > .item-price > span {

        text-decoration: line-through;
    }
    .unavailable-reason {

        color: rgb( 173, 8, 8 ) !important;
    }
    .strikethrough {

        text-decoration: line-through;
        color: #d88c00 !important;
    }
    .item-quantity {

        flex: 1;
        align-self: center;
        color: green;
    }
    .item-details {

        flex: 8;
    }
        .item-name {

            margin: 0;
            font-size: 1.1rem;
            font-weight: 600;
        }
        .item-modifier {

            margin: 0;
            color: #777;
        }
    .item-price {

        flex: 1;
        align-self: center;
        text-align: center;
    }

    .order-note {

        padding: 8px 0px;
        font-size: 0.9rem;
        font-weight: bold;
        color: #777;
    }
    .order-note > textarea {

        width: 100%;
        margin: 0px 1px;
    }

    .edit-button {

        margin: 0;
        width: 35px;
        color: rgb( 21, 66, 198 );
        cursor: pointer;
    }
    .remove-button {

        margin: 0;
        color: rgb( 173, 8, 8 );
        cursor: pointer;
    }

    .order-fees-wrapper {

        padding: 0px 15px;
    }
    .order-fees-wrapper > div {

        display: flex;
        justify-content: space-between;
    }
    .order-fees-wrapper > div > p {

        margin: 5px 0;
    }
    .order-fees-wrapper > div > p:first-child {

    }
    .order-fees-wrapper > div > p:nth-child( 2 ) {

        color: green;
    }

    .order-total-wrapper {

        border-top: 1px solid #ccc;
        height: 40px;
        margin-top: 5px;
        box-sizing: border-box;
        font-weight: bold;
        font-size: 17px;
    }


    .no-card {

        font-weight: bold;
        color: red;
    }
    .order-payment-wrapper {

        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        height: 52px;
    }
    .order-payment-details > img {

        width: 35px;
        height: 21px;
    }

    .order-payment-details {

        display: flex;
        justify-content: space-between;
        align-items: center;
    }
        .card-details {

            padding-left: 15px;
            font-weight: bold;
            margin: 0;
        }

    .save-card {

        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-weight: bold;
        height: 100%;
    }

    .save-card > input {

        height: 25px;
        width: 35px;
    }

    .checkout-tab {

        margin-top: 10px;
        position: relative;
    }
    .checkout-tab > button {

        width: 100%;
        height: 50px;
        font-size: 18px;
        padding: 0;
    }
</style>